import React from "react";
import PurchaseTable from "../components/Tables/PurchaseTable";

const TokenPurchase = () => {
  return <PurchaseTable />;
};

export default TokenPurchase;
